import { GridStackNode } from 'gridstack';
import * as uuid from 'uuid';
import { WidgetSettingType } from '../types/widget-setting.type';

export class Widget {
  get id(): string {
    return this._id;
  }
  set id(value: string) {
    this._id = value;
    this.updateOptions();
  }

  get width(): number {
    return this._width;
  }
  set width(value: number) {
    this._width = value;
    this.updateOptions();
  }

  get height(): number {
    return this._height;
  }
  set height(value: number) {
    this._height = value;
    this.updateOptions();
  }

  public minWidth: number;
  public maxWidth: number;
  public minHeight: number;
  public maxHeight: number;

  private _id = uuid.v4();
  public title = '';
  public icon = '';
  public frontId = '';

  public x = 0;
  public y = 0;

  private _width: number;
  private _height: number;

  public visible = true;

  public options: GridStackNode = {
    id: this._id,
  };

  constructor(id: string, title: string, icon: string, frontId: string) {
    this.id = id;
    this.title = title;
    this.icon = icon;
    this.frontId = frontId;
    this.updateOptions();
  }

  private updateOptions(): void {
    this.options = {
      id: this._id,
      w: this._width,
      h: this._height,
      minH: this.minHeight,
      maxH: this.maxHeight,
      maxW: this.maxWidth,
      minW: this.minWidth,
      x: this.x,
      y: this.y,
    };
  }

  public applySettings(settings: WidgetSettingType): void {
    this.x = settings.x;
    this.y = settings.y;
    this.width = settings.width;
    this.height = settings.height;
    this.visible = settings.visible;
    this.updateOptions();
  }

  public serialize(): WidgetSettingType {
    return {
      id: this.id,
      height: this.height,
      width: this.width,
      x: this.x,
      y: this.y,
      visible: this.visible,
    };
  }
}
